var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChair(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 260 99",
    style: {
      enableBackground: "new 0 0 260 99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EDEDED;}\n\t.st1{fill:#9E9E9E;}\n\t.st2{fill:#B0B0B0;}\n\t.st3{fill:#A3A3A3;}\n\t.st4{fill:#E5E5E5;}\n\t.st5{fill:#C2C2C2;}\n\t.st6{fill:#DBDBDB;}\n\t.st7{fill:#C3C3C3;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127,85.7c-16.8,0-32.4,0.4-45.6,1c0.9,0.5,1.5,1.5,1.5,2.6c0,1.7-1.3,3-3,3H68.5l0,0l0,0H57c-1.7,0-3-1.3-3-3 c0-0.2,0-0.3,0-0.5c-8,1-12.6,2.2-12.6,3.4c0,3.6,38.3,6.6,85.6,6.6c47.3,0,85.6-2.9,85.6-6.6c0-1.3-4.6-2.4-12.6-3.4 c0,0.1,0,0.3,0,0.5c0,1.7-1.3,3-3,3h-11.4l0,0l0,0h-11.4c-1.7,0-3-1.3-3-3c0-1.1,0.6-2.1,1.5-2.6C159.4,86.1,143.8,85.7,127,85.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.5,77.3h-6v9h6V77.3 M71.5,62.4h-6v6h6V62.4 M71.5,50.4h-6v3h6V50.4 M68.5,32.5c-1.7,0-3,1.3-3,3v6h6v-6 C71.5,33.8,70.1,32.5,68.5,32.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.5,77.3h-6v9h6V77.3 M188.5,62.4h-6v6h6V62.4 M188.5,50.4h-6v3h6V50.4 M185.5,32.5c-1.7,0-3,1.3-3,3v6h6 v-6C188.5,33.8,187.2,32.5,185.5,32.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.9,86.3h-8.4h-6H57c-1.5,0-2.7,1.1-3,2.5c0,0.1,0,0.3,0,0.5c0,1.7,1.3,3,3,3h11.4h11.4c1.7,0,3-1.3,3-3 c0-1.1-0.6-2.1-1.5-2.6C81,86.4,80.4,86.3,79.9,86.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M197,86.3h-8.4h-6h-8.4c-0.6,0-1.1,0.2-1.5,0.4c-0.9,0.5-1.5,1.5-1.5,2.6c0,1.7,1.3,3,3,3h11.4H197 c1.7,0,3-1.3,3-3c0-0.2,0-0.3,0-0.5C199.7,87.4,198.5,86.3,197,86.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M203.6,68.4h-15h-6H71.5h-6h-15c-1.3,0-2.6,0.4-3.6,1.2l-4.4,3.3c-0.6,0.5-1,1.2-1,2c0,0.1,0,0.1,0,0.2 c0.1-1.1,1-1.9,2.1-1.9h166.9c1.1,0,2,0.8,2.1,1.9c0.1-0.8-0.3-1.7-1-2.2l-4.4-3.3C206.1,68.8,204.9,68.4,203.6,68.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M205.4,53.4h-16.8h-6H71.5h-6H48.6c-0.7,0-1.2,0.5-1.2,1.2v6.6c0,0.7,0.5,1.2,1.2,1.2h16.8h6h111.1h6h16.8 c0.7,0,1.2-0.5,1.2-1.2v-6.6C206.6,53.9,206,53.4,205.4,53.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M205.4,41.4h-16.8h-6H71.5h-6H48.6c-0.7,0-1.2,0.5-1.2,1.2v6.6c0,0.7,0.5,1.2,1.2,1.2h16.8h6h111.1h6h16.8 c0.7,0,1.2-0.5,1.2-1.2v-6.6C206.6,42,206,41.4,205.4,41.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M210.5,73.1H43.5c-1.1,0-2,0.8-2.1,1.9c0,0.1,0,0.1,0,0.2c0,1.2,0.9,2.1,2.1,2.1h0.4h166.1h0.4 c1.2,0,2.1-0.9,2.1-2.1c0-0.1,0-0.1,0-0.2C212.5,74,211.6,73.1,210.5,73.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M60.1,2c-3,0-5.4,2.4-5.4,5.4c0.2,0.5,0.5,0.8,1,0.8c0.7,0,1-0.8,1-0.8c0-1.9,1.6-3.5,3.5-3.5 c1.9,0,3.5,1.5,3.5,3.5s-1.6,3.5-3.5,3.5V11c-0.1,0-0.2-0.1-0.3-0.1H42.9c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h16.8 c0.1,0,0.2,0,0.3-0.1v0.1c3,0,5.4-2.4,5.4-5.4S63,2,60.1,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M169.9,12.1L169.9,12.1c-0.1,0-0.2,0-0.3,0h-9c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h9 c0.1,0,0.2,0,0.3,0v0.2c1.9,0,3.5,1.5,3.5,3.5s-1.6,3.5-3.5,3.5c-1.9,0-3.5-1.5-3.5-3.5c0,0-0.3-0.8-1-0.8c-0.5,0-0.8,0.3-1,0.8 c0,3,2.4,5.4,5.4,5.4c3,0,5.4-2.4,5.4-5.4C175.3,14.6,172.9,12.1,169.9,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M46.6,6.2H30.9c-0.5,0-0.9,0.4-0.9,0.9C30,7.6,30.4,8,30.9,8h15.6c0.5,0,0.9-0.4,0.9-0.9 C47.4,6.6,47,6.2,46.6,6.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M155.2,16.9h-15.6c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h15.6c0.5,0,0.9-0.4,0.9-0.9 C156.1,17.3,155.7,16.9,155.2,16.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M226.7,0.2H199c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h27.6c0.5,0,0.9-0.4,0.9-0.9 C227.6,0.6,227.2,0.2,226.7,0.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M97,22.9H69.4c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9H97c0.5,0,0.9-0.4,0.9-0.9 C97.9,23.3,97.5,22.9,97,22.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M23.1,32.5H1.5c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h21.6c0.5,0,0.9-0.4,0.9-0.9 C24,32.9,23.6,32.5,23.1,32.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M232.7,40.8h-15.6c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h15.6c0.5,0,0.9-0.4,0.9-0.9 C233.6,41.2,233.2,40.8,232.7,40.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M27.9,6.2h-3c-0.5,0-0.9,0.4-0.9,0.9C24,7.6,24.4,8,24.9,8h3c0.5,0,0.9-0.4,0.9-0.9 C28.8,6.6,28.4,6.2,27.9,6.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M121.6,9.8h-3c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h3c0.5,0,0.9-0.4,0.9-0.9 C122.5,10.2,122.1,9.8,121.6,9.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M157.6,12.1L157.6,12.1c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h0c0.5,0,0.9-0.4,0.9-0.9 C158.5,12.5,158.1,12.1,157.6,12.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M196.1,0.2h-1.2c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9h1.2c0.5,0,0.9-0.4,0.9-0.9 C197,0.6,196.5,0.2,196.1,0.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.9,87.5l-0.5,1.1c1.4,0.7,2.5,1.2,3.4,1.4c-0.1-0.2-0.2-0.5-0.2-0.7c0-0.2,0-0.4,0.1-0.5 C15,88.5,14,88.1,12.9,87.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M21.3,86.3c-2.8,0-5.1,1.1-5.6,2.5c-0.1,0.2-0.1,0.4-0.1,0.5c0,0.3,0.1,0.5,0.2,0.7c0.6,1.3,2.9,2.3,5.5,2.3 c3.2,0,5.7-1.3,5.7-3C27,87.6,24.5,86.3,21.3,86.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.5,25.8c-0.6,0.4-1.5,0.8-2.6,1.2l0.5,1.1c1.3-0.5,2.3-1,3-1.5c-0.2-0.1-0.3-0.2-0.5-0.3 C212.7,26.2,212.6,26,212.5,25.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M219,17.2c-1.4,0-3.2,1.1-4.7,2.9c-1.7,2.1-2.4,4.4-1.8,5.7c0.1,0.2,0.2,0.4,0.4,0.6c0.1,0.1,0.3,0.2,0.5,0.3 c0.2,0.1,0.5,0.1,0.8,0.1c1.4,0,3.2-1.1,4.7-2.9c2-2.4,2.6-5.2,1.4-6.3C219.9,17.4,219.5,17.2,219,17.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.3,32.2c0,0.1-0.1,0.1-0.1,0.1c-0.2,0.3-0.5,0.4-0.9,0.6c0.1,0.1,0.3,0.4,0.5,0.8c0.2,0.5,0.4,1.1,0.6,1.9 l1.2-0.3c-0.2-0.8-0.4-1.5-0.7-2.1C126.8,32.9,126.6,32.5,126.3,32.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M121,25.9c-0.7,0-1.3,0.2-1.6,0.7c-1,1.1-0.2,3.4,1.7,5c1.2,1,2.5,1.5,3.5,1.5c0.3,0,0.5,0,0.8-0.1 c0.3-0.1,0.6-0.3,0.9-0.6c0,0,0.1-0.1,0.1-0.1c0.8-1.2,0-3.3-1.8-4.8C123.3,26.5,122,25.9,121,25.9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChair);
export default __webpack_public_path__ + "static/media/chair.ef309a3c99909aa81eff2cdb9f16c342.svg";
export { ForwardRef as ReactComponent };